import { Box } from "@mui/material"
import { UserModal } from "./UserModal"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClientData } from "../../types";

interface AddUserProps {
  clients: ClientData[];
  refetchUsers: () => void;
}

export const AddUser = ({ clients, refetchUsers }: AddUserProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    navigate('/users');
  }
  
  const handleSave = () => {
    navigate('/users');
    refetchUsers();
  }
  
  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="add-user">
      <UserModal open={open} handleClose={handleClose} handleSave={handleSave} clients={clients} user={{ }} />
    </Box>
  )
}